import { useEffect, useRef, useState } from "react"

export const useElementOnScreen = (options: any, animate: boolean = true) => {
  const containerRef: any = useRef(null)
  const [ key, setKey ] = useState(0);

  useEffect(() => {
    
    const observer = new IntersectionObserver((entries: any) => {
        const [ entry ] = entries
        if (entry.isIntersecting) {
            setKey(val => val + 1)
            observer.unobserve(containerRef.current)
        }
    }, options)
    if (containerRef.current) observer.observe(containerRef.current)
    
    return () => {
      if(containerRef.current) observer.unobserve(containerRef.current)
    }
  }, [])
  
  return animate ? [ containerRef, key ] : [ containerRef, 1 ];
}